import { CheckoutEvent } from './checkout-event.interface';
import { CheckoutStatus } from './checkout-status.type';

export interface CheckoutEventTimeout extends CheckoutEvent {
  transactionId: string;
  status: CheckoutStatus;
}
